<template>
  <div v-if="isVisible" class="cookies">
    <div class="cookies-text">
      <h1>Aviso de Cookies</h1>
      O SEBRAE realiza a coleta de cookies dos usuários e visitantes de seu
      website para fornecer uma navegação aprimorada, assim como otimizar os
      seus serviços de marketing. Os cookies coletados, independente de sua
      categoria, são utilizados unicamente para atendimento à sua finalidade de
      tratamento que foi pré-estabelecida em nossa
      <a
        href="https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf"
        target="_blank"
        >Política de Privacidade</a
      >.
    </div>

    <button @click="setCookie()">Aceitar</button>
  </div>
</template>

<script>
export default {
  name: "Cookies",
  data() {
    return {
      isVisible: true
    };
  },
  methods: {
    setCookie() {
      this.$cookie.set("accepedtedCookies", "true", 7);
      this.isVisible = false;
    }
  },
  mounted() {
    if (this.$cookie.get("accepedtedCookies")) {
      this.isVisible = false;
    } else {
      this.isVisible = true;
    }
  }
};
</script>

<style lang="scss">
.cookies {
  font-size: 0.813em;
  background: #0f6fc6;
  color: #fff;
  position: fixed;
  bottom: 0;
  padding: 2rem;
  display: flex;
  align-items: center;
  z-index: 999999;
  &-text {
    max-width: 90%;
    padding-right: 2rem;
    a {
      color: #fff !important;
      text-decoration: underline;
      font-weight: bold;
    }
  }

  button {
    color: #0f6fc6;
    border-color: #0f6fc6;
    background-color: #ffffff;
    min-width: 125px;
    height: 50%;
    white-space: normal;
    word-break: break-word;
    word-wrap: break-word;
    padding: 12px 10px;
    line-height: 1.2;
    font-size: 0.8rem;
    font-weight: 600;
  }
}
</style>
